<style lang="less" rel="stylesheet/stylus" scoped>
.login_box {
  width: 100%;
  height: 100%;
  background: #0089ce;
  .login_content {
    width: 500px;
    .title {
      font-family: PingFang_Medium;
      font-size: 37px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 37px;
    }
    p {
      opacity: 0.5;
      font-family: PingFang_Regular;
      font-size: 28px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 28px;
      margin-top: 25px;
    }
    .inputBox {
      position: relative;
      input {
        outline: none;
        height: 100%;
        width: 461px;
        font-size: 37px;
        line-height: 37px;
        margin-top: 61px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        color: #ffffff;
        text-align: left;
        padding-bottom: 20px;
      }
      .inputs {
        -webkit-text-fill-color: white;
      }
      .clear_tel {
        position: absolute;
        right: 22px;
        bottom: 29px;
        background: url("/static/img/login/clear.png") no-repeat;
        width: 30px;
        height: 30px;
        background-size: 100%;
        z-index: 2;
        /*animation: .5s clear_tel 1;*/
        animation: 0.5s zoomIn 1;
      }
    }
    .feedback {
      margin-top: 31px;
      text-align: left;
      padding-left: 30px;
      color: #fff;
      opacity: 1;
      font-size: 22px;
      span {
        text-decoration: underline;
      }
    }
    .login_btn {
      margin-top: 63px;
      width: 460px;
      height: 73px;
      font-size: 31px;
      line-height: 73px;
      text-align: center;
      color: #0089ce;
      background: #fff;
      opacity: .4;
      transition-duration: 0.5s;
      margin-left: 18px;
      border-radius: 66px;
      cursor: default;
    }
    .login_btn_cur {
      color: #007a9c;
      cursor: pointer;
      background: #ffffff;
      opacity: 1;
    }
    .login_btn_cur:hover {
      background: #cce7f5;
      color: #0077B5;
    }
  }
}
.exitapp {
  height: 50px;
  position: fixed;
  bottom: 0;
  width: 100%;
  font-size: 18px;
  color: #003b61;
  span:hover {
    color: #66afc3;
  }
  .gocompany {
    margin-left: 20px;
  }
}
.go_limishuxue {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 84px;
  opacity: 0.3;
  font-size: 18px;
  color: #ffffff;
  line-height: 18px;
  width: 100%;
}
@media screen and (max-height: 668px) {
  .go_limishuxue {
    bottom: 30px;
  }
}
</style>
<template>
  <div class="container">
    <alert
      :sameTwo="alertText"
      :cancal="isShow == 2?'取消':tipText"
      :btn="isShow == 2?'重新输入':''"
      :show="show"
      @cancelEvent="closeAlert"
    ></alert>
    <alert
      :sameTwo="alertTextTwo"
      :btn="'我知道了'"
      :show="isPass"
      @ensure="iKnow"
    ></alert>
    <div class="login_box">
      <div class="login_content">
        <div class="inputBox">
          <input
            type="tel"
            maxlength="13"
            v-model="phone"
            class="user_tel"
            :class="{'inputs':phone}"
            @keyup.enter="loginIn"
          >
          <div class="clear_tel cursor" @click="clear_tel" v-show="phone.length"></div>
        </div>
        <p class="feedback">遇到问题，<span class="cursor" @click="gopage">点击这里反馈</span></p>
        <div
          class="login_btn"
          :class="{'login_btn_cur':phone.replace(/\s/g, '').length == 11}"
          @click="loginIn"
        >下一步</div>
      </div>
    </div>
  </div>
</template>
<script>
import Back from "@/components/basic/back.vue";
import icp from "@/components/basic/icp.vue";
import alert from "@/components/basic/alert.vue";
import toast from "@/components/basic/toast.vue";
import common from "common";
import liSrv from "liSrv";
import utils from "utils";
import { mapState, mapMutations, mapActions } from "vuex";
if (LIMI_ENV === "electron") {
  var { shell } = window.require("electron");
  var ipc = window.require("electron").ipcRenderer;
}
export default {
  name: "loginOld",
  data() {
    return {
      phone: "",
      isShow: 0,
      alertText: "请输入号码",
      tipText: "重新输入",
      sureText: "",
      show: false,
      // showBack: true,
      LIMI_ENV: LIMI_ENV === "electron",
      alertTextTwo: '出错了，请稍后重试~',
      isPass: false,

    };
  },
  components: {
    alert,
    toast,
    Back,
    icp,
  },
  computed: {
    ...mapState(["COOK"])
  },
  beforeCreate() {
    liSrv.getAPIList(res => {
      this.$store.commit("saveIndexConfig", res);
      if(LIMI_ENV==="electron"){
        res.assetZip.forEach((url)=>{
          ipc.send('loadKeJian',{
            url:url
          })
        })
        res.kejianSound.sound.forEach((url)=>{
          ipc.send('loadKeJian',{
            url:url
          })
        });
      }
    });
  },
  created() {
    if (this.COOK) {
      this.$router.go(-1);
    }
    this.phone = (LIMI_ENV === "electron" ? utils.getNodeStorge("phone") : common.get("phone")) || "";
  },
  mounted() {
    // this.$route.query.from == "userInfo" ? (this.showBack = false) : null;
    this.$nextTick(() => {
      // this.$refs.inputDom.focus();
    });
  },
  methods: {
    //登录http请求
    ...mapMutations(["refreshNet","saveLogin"]),
    ...mapActions(["loginModel"]),
    gopage() {
      this.$emit('gopage')
    },
    //效验手机号
    checkNumber(data) {
      if (data && data.length == 11) {
        return true;
      } else {
        return false;
      }
    },
    //关闭按钮
    closeAlert() {
      this.show = false;
    },
    //点击登录
    loginIn() {
      this.$root.eventHub.$emit("createLog", { id: "LMTrackEventLogin" });
      let phone = this.phone.replace(/\s/g, "");
      if (phone == "80000000008") {
        common.set("showDebug", true);
        window.location.reload();
        return;
      }
      if(LIMI_ENV === "electron" && phone == "70000000007"){
        utils.setNodeStorge("playerType","flv");
        common.remove('live_video_url_now');
        common.remove('liveVideoUrlData');
        window.location.reload();
        return
      }
      if (!navigator.onLine) {
        this.refreshNet(false);
        return;
      }
      if (!common.API) {
        liSrv.getAPIList(res => {
          this.$store.commit("saveIndexConfig", res);
          this.loginReal();
        });
        return;
      }
      this.loginReal();
    },
    loginReal() {
      let phone = this.phone.replace(/\s/g, "");
      if (this.checkNumber(phone)) {
        this.loadingShow = true;
        this.loginModel({phonenum:phone,usertype:'student'})
          .then(({ res, ok }) => {
            if (ok) {
              if (res.status) {
                if(res.memberStatus === 2 || res.memberStatus === 3) {
                  this.isPass = true;
                  this.alertTextTwo = '您还未开通会员服务，请在微信中搜索并关注【狸米新启航】公众号，开通会员后再登录';
                }else if(res.memberStatus === 4) {
                  this.isPass = true;
                  this.alertTextTwo = '您的会员服务已过期，请在微信中搜索并关注【狸米新启航】公众号，开通会员后再登录';
                }else {
                  LIMI_ENV === "electron" && utils.setNodeStorge("phone",phone);
                  this.saveLogin({phone});
                  common.set("phone", phone);
                  this.$router.replace({
                    path: '/password',
                    query: {
                      loginType: 2
                    }
                  });
                }
              } else {
                this.isShow = 1;
                this.alertText = "该账号不存在，请重新输入";
                this.show = true;
              }
            }
          })
      }
    },
    clear_tel() {
      this.phone = "";
    },
    iKnow() {
      this.isPass = false;
    }
  },
  watch: {
    //手机号 3 4 4 格式
    phone(newValue, oldValue) {
      let val = newValue.replace(/[^0-9]/g, "");
      val = val.length > 11 ? val.substr(0, 11) : val;
      if (newValue.length >= oldValue.length || newValue.length == 11) {
        if (val.replace(/\s/g, "").length < 3) {
          this.phone = val.replace(/\s/g, "");
        } else if (
          val.replace(/\s/g, "").length >= 3 &&
          val.replace(/\s/g, "").length < 7
        ) {
          this.phone = val.replace(/\s/g, "").replace(/(\d{3})/, "$1 ");
        } else if (val.replace(/\s/g, "").length >= 7) {
          this.phone = val
            .replace(/\s/g, "")
            .replace(/(\d{3})(\d{4})/, "$1 $2 ");
        }
      } else {
        this.phone = this.phone.trim();
      }
    }
  },
  directives: {
    focus: el => {
      el.focus();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/bussiness/login/paw-login.vue